import React from 'react';

import {labels} from '../../../../../../../util/utils';

export const prop = 'pGaapIfrs';

const getGaap = (item) => {
	let result = '';

	// checks whether the value is zero or or null/undefined
	if (item.pGaapIfrs) {
		result = labels.ifrs;
	} else if (item.pGaapUS) {
		result = labels.pGaapUS;
	} else if (item.pGaapOther) {
		result = labels.other;
	}

	return result;
};

export const config = (labels) => ({
	id: 'gaapColumn',
	label: labels.gaap,
	propName: prop,
	width: 'minmax(var(--px-130), 1fr)',
	sortBy: prop,
	customCell: (item) => getGaap(item)
});
